import React, { useState } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import PhotoSelectionOverlayModal from '../../../../PurchasingOptions/components/DigitalBundleOption/components/PhotoSelectionOverlayModal';
import { getIdentityName } from '../../../../../../../../../../util/identity';
import Button from '../../../../../../../../../../components/global/Button';
import { getAsset } from '../../../../../../../../../../util/assets';

const propTypes = {
  purchasedDigitalBundle: PropTypes.shape({
    id: PropTypes.string,
    identity: PropTypes.shape({
      id: PropTypes.string,
    }),
    digital_bundle: PropTypes.shape({
      id: PropTypes.string,
      album_folder: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    photos_count: PropTypes.number,
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        total: PropTypes.number,
      }),
    ),
  }).isRequired,
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  onConfigurationComplete: PropTypes.func.isRequired,
  isAllPhotos: PropTypes.bool,
  disabled: PropTypes.bool,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const PurchasedDigitalBundleOption = ({
  purchasedDigitalBundle,
  albumMembershipGroup,
  onConfigurationComplete,
  isAllPhotos,
  disabled,
  watermarkSettings,
}) => {
  const [photoSelectorOpen, setPhotoSelectorOpen] = useState(false);
  const identityName = getIdentityName(purchasedDigitalBundle.identity);
  const missingPhotos =
    purchasedDigitalBundle.photos_count - purchasedDigitalBundle.photos.total;

  const identityCopy = purchasedDigitalBundle.digital_bundle.is_multi_identity
    ? 'Your'
    : `${identityName}'s`;

  return (
    <div className="purchased-digital-bundle-option">
      <div className="purchased-digital-bundle-option-thumb">
        <img width={75} src={getAsset('/photopass.svg')} alt="" />
      </div>
      <div className="purchased-digital-bundle-option-content-wrap text-sm">
        {identityCopy}{' '}
        {pluralize('Photo', purchasedDigitalBundle.photos_count, true)} Bundle
        is missing <b>{pluralize('photo', missingPhotos, true)}</b>
        <div className="mt-1">
          <Button
            btnSize="sm"
            btnOutline
            pill
            disabled={disabled}
            onClick={() => setPhotoSelectorOpen(true)}
          >
            {disabled ? 'Loading...' : 'Configure Now'}
          </Button>
        </div>
      </div>
      <PhotoSelectionOverlayModal
        forceOpen={photoSelectorOpen}
        albumMembershipGroupId={
          isAllPhotos
            ? undefined
            : albumMembershipGroup?.id ??
              purchasedDigitalBundle.digital_bundle.album_folder.id
        }
        albumId={isAllPhotos ? albumMembershipGroup?.id : undefined}
        identityId={
          purchasedDigitalBundle.digital_bundle.is_multi_identity
            ? undefined
            : purchasedDigitalBundle.identity.id
        }
        maxPhotos={missingPhotos}
        onClose={() => setPhotoSelectorOpen(false)}
        onComplete={({ photos }) =>
          onConfigurationComplete({ photoIds: photos.map(photo => photo.id) })
        }
        watermarkSettings={watermarkSettings}
      />
    </div>
  );
};

PurchasedDigitalBundleOption.propTypes = propTypes;

export default PurchasedDigitalBundleOption;
